<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="text-h6 grey lighten-2">
          <b>Revertir Descuento</b>
        </v-card-title>

        <v-card-text class="pt-4">
          <p class="mb-0"><b>Programa:</b> {{ datas.programa }}</p>

          <div v-if="descuento.monto" class="mt-1">
            <p class="mb-0"><b>Concepto:</b> {{ descuento.concepto_pago.nombre }}</p>
            <p class="mb-0"><b>Monto de descuento:</b> {{ descuento.monto }} Bs.</p>
            <p class="mb-0"><b>Prorrateo:</b> {{ descuento.prorrateadoActivo ? 'SI' : 'NO' }}</p>
            <p class="mb-2"><b>Estado:</b> {{ descuento.estado }}</p>
            <p class="mb-1"><b>Descripcion:</b> {{ descuento.descripcion }}</p>
            <p class="mb-1"><b>Solicitado:</b> {{ parsefecha(descuento.fecha_registro) }}</p>
            <p class="mb-1"><b>Respondido:</b> {{ parsefecha2(descuento.fecha_respuesta_solicitud) }}</p>
            <p class="mb-1"><b>Motivo:</b> {{ descuento.motivo.descripcion }}</p>
            <p class="mb-2">
              <b>Estudiante:</b> {{ datas.nombres }} {{ datas.primer_apellido }} {{ datas.segundo_apellido }}
            </p>
            <p class="mb-1"><b>Solicitante:</b> {{ parseuser(descuento.user_solicitante) }}</p>
            <p class="mb-1"><b>Responsable:</b> {{ parseuser(descuento.user_responsable) }}</p>
          </div>

          <p class="text-center red--text mt-2 mb-0"><b>{{ msg }}</b></p>
          <v-progress-linear indeterminate v-if="loading" class="mt-2" />

          <div class="mt-3">
            <p class="mb-1 blue--text">
              <b>Para continuar escriba: <span class="red--text">{{ estado }}</span> para proceder.</b>
            </p>
            <v-text-field
              v-model="proceder_text"
              outlined
              dense
              hide-details
            />
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" outlined @click="dialog = false">
            <v-icon small left>mdi-close</v-icon>
            Cerrar
          </v-btn>
          <v-btn
            color="primary"
            outlined
            :disabled="loading || !proceder_text || proceder_text != estado"
            @click="validarCampos()"
          >
            <v-icon small left>mdi-undo</v-icon>
            Proceder a la reversion
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        dialog: false,
        descuento: {},
        loading: false,
        msg: '',
        estado: 'revertir',
        respuesta: '',
        proceder_text: '',
        datas: { nombres: '' },
      };
    },
    methods: {
      setdescuento(desc) {
        if (!desc.concepto_pago) desc.concepto_pago = { nombre: '-' };
        this.descuento = desc;
        this.msg = '';
        this.respuesta = '';
        this.proceder_text = '';
        this.loading = false;
        this.datas = { nombres: '' };
        this.getinscripcion(desc);
        this.dialog = true;
      },
      validarCampos() {
        this.msg = '';
        let userid = this.$store.state.DATA_USER.id;
        if (userid == 43) {
          this.msg = 'usuario no autorizado';
          return;
        }
        let data = { id: this.descuento.id };
        this.enviarrespuesta(data);
      },
      enviarrespuesta(data) {
        this.msg = '';
        const vue = this;
        vue.loading = true;
        window.console.log(data);

        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/pagos/descuentos/${this.descuento.id}/reversion`;
        window.console.log(url);
        xaxios
          .post(url, data)
          .then((res) => {
            window.console.log(res);
            vue.loading = false;
            if (res.status == 200) {
              setTimeout(() => { vue.dialog = false; }, 300);
              vue.$emit('onrespuesta');
            }
          })
          .catch((error) => {
            window.console.error(error);
            vue.loading = false;
            if (error.response) {
              vue.msg = error.response.data.data;
            }
          });
      },
      getinscripcion(desc) {
        const vue = this;
        vue.datas.nombres = desc.estudiante.nombres;
        vue.datas.primer_apellido = desc.estudiante.primer_apellido;
        vue.datas.segundo_apellido = desc.estudiante.segundo_apellido;
        vue.datas.numero_documento = desc.estudiante.numero_documento;
        vue.datas.programa = desc.programa.nombre;
      },
      parseuser(u) {
        if (!u) return '-';
        if (!u.segundo_apellido) u.segundo_apellido = '';
        return `${u.nombres} ${u.primer_apellido} ${u.segundo_apellido}`;
      },
      parsefecha(f) {
        if (!f) return '-';
        let fs = f.split(' ');
        let fs1 = fs[0].split('-');
        let fs2 = fs[1].split(':');
        return `${fs1[2]}/${fs1[1]}/${fs1[0]} ${fs2[0]}:${fs2[1]}`;
      },
      parsefecha2(f) {
        if (!f) return '-';
        let fs = f.split(' ');
        let fs1 = fs[0].split('-');
        return `${fs1[2]}/${fs1[1]}/${fs1[0]}`;
      },
    },
  };
</script>
